import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { usePathname, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

const useShareableUrl = (props?: { searchParams?: { [key in string]: string } }) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isThankYouPage = usePageStore((state) => state.isThankYouPage)
  const currentUrlFromStore = usePageStore((state) => state.currentUrl)

  const currentUrl = useMemo(() => {
    // Build the base URL
    const baseUrl = (currentUrlFromStore || (typeof window !== 'undefined' ? window.location.origin : ''))?.replace(
      '/thanks',
      '',
    )

    if (!baseUrl) {
      return ''
    }

    const url = new URL(baseUrl)

    if (props?.searchParams) {
      // Start with existing params, we only really care about mode
      const filteredParams = new URLSearchParams(Array.from(searchParams.entries()).filter(([key]) => key === 'mode'))

      // Add custom params
      if (props.searchParams) {
        for (const [key, value] of Object.entries(props.searchParams)) {
          filteredParams.set(key, value)
        }
      }

      url.search = filteredParams.toString()
    } else {
      url.search = searchParams.toString()
    }

    return url.toString()
  }, [currentUrlFromStore, pathname, isThankYouPage, searchParams, props?.searchParams])

  return currentUrl
}

export default useShareableUrl
